var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02481 0.901L2.92731 2.575L4.62231 0.488C4.66977 0.429655 4.72979 0.38277 4.79788 0.350835C4.86598 0.318901 4.9404 0.30274 5.01561 0.303557C5.09082 0.304374 5.16487 0.322148 5.23226 0.355554C5.29964 0.38896 5.35863 0.437138 5.40481 0.4965L7.02231 2.5745L8.98631 0.8765C9.06344 0.809955 9.15905 0.768555 9.26035 0.757841C9.36165 0.747127 9.46381 0.76761 9.55315 0.816549C9.64249 0.865488 9.71475 0.940548 9.76026 1.03168C9.80578 1.12282 9.82236 1.22568 9.80781 1.3265L9.05781 6.5H0.961311L0.19981 1.35C0.184684 1.24862 0.201083 1.14504 0.246786 1.05328C0.292488 0.961533 0.365287 0.886045 0.455321 0.837044C0.545355 0.788044 0.648273 0.7679 0.750137 0.779339C0.852001 0.790779 0.947888 0.83325 1.02481 0.901ZM1.00031 7H9.00031V7.5C9.00031 7.63261 8.94763 7.75979 8.85386 7.85355C8.7601 7.94732 8.63292 8 8.50031 8H1.50031C1.3677 8 1.24053 7.94732 1.14676 7.85355C1.05299 7.75979 1.00031 7.63261 1.00031 7.5V7Z",
    fill: "#FFD233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.30a2a199.svg";
export { ForwardRef as ReactComponent };